"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardPages = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DashboardPages = function DashboardPages(props) {
  var data = props.data,
      loading = props.loading;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dashboard-table"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-column",
    style: {
      color: '#338CE4'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "header"
  }, "Recently edited pages"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "view-all"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/pages",
    activeClassName: "active"
  }, "View All"))), loading ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-column"
  }, "Pages Loading...") : /*#__PURE__*/_react["default"].createElement("div", null, !data || data <= 1 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-column"
  }, "No results found") : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-column",
    style: {
      color: '#212529'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '50%'
    }
  }, "Name"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '25%'
    }
  }, "Modified By"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '25%'
    }
  }, "Locale")), data.map(function (pages) {
    var _pages$modifiedBy, _pages$modifiedBy2;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: pages.id,
      className: "table-column"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: '#338CE4',
        width: '50%'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
      to: "/content/edit/page/".concat(pages.id),
      activeClassName: "active"
    }, pages.name)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '25%'
      }
    }, "".concat((_pages$modifiedBy = pages.modifiedBy) === null || _pages$modifiedBy === void 0 ? void 0 : _pages$modifiedBy.firstName, " \n                                        ").concat((_pages$modifiedBy2 = pages.modifiedBy) === null || _pages$modifiedBy2 === void 0 ? void 0 : _pages$modifiedBy2.lastName)), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '25%'
      }
    }, pages.locale));
  }))));
};

exports.DashboardPages = DashboardPages;